import { EmailAlertTimelineTab } from './EmailAlertTimelineTab';
import { getSonarObjectTypeLabel } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { COPY_SONAR_OBJECT_BASE, PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { EmailAlertMetadataTab, EmailAlertWorkflowRulesTab } from '.';
import { PeriscopeMenuTabs, PeriscopeTabArea } from '@periscopes/general';
import { useOnMount, usePeriscopeActions } from '@hooks';
export const EmailAlertScope = ({ data, index }) => {
    var _a;
    const { relatedCounts, sonarObjectId } = data;
    const { updatePeriscope } = usePeriscopeActions();
    useOnMount(() => {
        updatePeriscope({
            headerLabel: COPY_SONAR_OBJECT_BASE.WORKFLOW_ACTION,
            periscopeIndex: index,
            subType: getSonarObjectTypeLabel(data.sonarObjectType)
        });
    });
    return (React.createElement(PeriscopeMenuTabs, null,
        React.createElement(PeriscopeTabArea, { key: PERISCOPE_TAB_TYPES.DETAILS, tab: PERISCOPE_TAB_TYPES.DETAILS },
            React.createElement(EmailAlertMetadataTab, { index: index, sonarObjectId: sonarObjectId })),
        React.createElement(PeriscopeTabArea, { count: (_a = relatedCounts[SonarObjectType.SalesforceWorkflowRule]) !== null && _a !== void 0 ? _a : 0, key: PERISCOPE_TAB_TYPES.WORKFLOW_RULES, requiresCount: true, tab: PERISCOPE_TAB_TYPES.WORKFLOW_RULES },
            React.createElement(EmailAlertWorkflowRulesTab, { index: index, sonarObjectId: sonarObjectId })),
        React.createElement(PeriscopeTabArea, { key: PERISCOPE_TAB_TYPES.ACTIVITY, tab: PERISCOPE_TAB_TYPES.ACTIVITY },
            React.createElement(EmailAlertTimelineTab, { sonarObjectId: sonarObjectId }))));
};
